export const attachments = [
    {
        id: 1,
        name: "fw9__1_.pdf",
        uploadOn: "11/04/2021"
    },
    {
        id: 2,
        name: "Landlord_Tenant_Info_Pamphlet__11-2014___1_.pdf",
        uploadOn: "03/06/2021"
    }
];

export const leasTemplates =[
    "New Move in Lease Template",
    "New Move in Lease Template Copy (TEST)",
    "Renewal Lease Template",
    "Sample Lease Template"
  ];

  export const templates = [
    {
        value: "New Move in Lease Template",
    },
    {
        value: "New Move in Lease Template Copy (TEST)",
    },
    {
        value: "Renewal Lease Template",
    },
    {
        value: "Sample Lease Template",
    }
  ];